export const enum ServiceEventEnums {
  CREATION = 'created',
  UPDATE = 'updated',
  REJECTION = 'correction_requested',
  DELIVERY = 'delivered'
}

export type ServiceEventTypes = ServiceEventEnums.CREATION | ServiceEventEnums.UPDATE | ServiceEventEnums.REJECTION | ServiceEventEnums.DELIVERY
